import {
  Stack,
  TextField,
  Paper,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  ListItemIcon,
  ListItemText,
  FormControl,
  Button,
  Typography,
  IconButton,
  CircularProgress,
  Snackbar,
  Alert,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TopHeading from "../../utils/TopHeading/TopHeading";
import CustomTable from "../../views/CustomTable/CustomTable";
import AnimatedPage from "../animatedPage/AnimatedPage";
import CustomTooltip from "../../../src/utils/CustomTooltip";
import Hoc from "../HOC/Hoc";
import { getActivepanels } from "../managePanel/managePanel.api";
import { getAllPanelistByPanelId } from "./panelistDetail.api";
import CustomDataTable from "../../views/CustomTable/CustomDataTable";
import DownloadIcon from "@mui/icons-material/Download";
import moment from "moment";
import * as XLSX from "xlsx";
// import CustomDataTableNew from "../../views/CustomTable/CustomDataTableNew";

const Panelists = () => {
  const [selectedPanel, setSelectedPanel] = useState({});
  const [panelists, setPanelists] = useState([]);
  const [pageloading, setPageloading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [defaultData, setDefaultData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const adminId = useSelector((state) => state.auth.userData?.tenantId);
  const [columns, setColumns] = useState([]);
  const [pending, setPending] = useState(true);
  const [activeUser, setActiveUser] = useState(true);
  const [loading, setLoading] = useState(false);
  const [userActiveStatusData, setUserActiveStatusData] = useState([
    { id: 0, userActiveStatus: "Active", ApiName: "getAllPanelistByPanelId" },
    { id: 1, userActiveStatus: "Inactive", ApiName: "getInactiveUser" },
  ]);
  const [selectedUserStatusType, setSelectedUserStatusType] = useState(
    userActiveStatusData[0],
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(200);
  const [totalRecords, setTotalRecords] = useState(200);
  const [totalDefaultRecords, setTotalDefaultRecords] = useState(200);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");
  const [showStatusColumn, setShowStatusColumn] = useState(false);

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleSnackbarMessage = (message, type) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(type);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    getActivepanels(adminId)
      .then((res) => {
        if (res?.status === 200) {
          setSelectedPanel(res.data.data[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    return () => {
      setSelectedPanel({});
    };
  }, [adminId]);

  useEffect(() => {
    if (Object.keys(selectedPanel).length > 0) {
      setPageloading(true);
      getAllPanelistByPanelId()
        .then((res) => {
          if (res?.status === 200) {
            if (res?.data?.success) {
              const panelistData = res?.data?.data;
              setPanelists(panelistData);
              setDefaultData(panelistData);
              setFilteredData(panelistData);
              setTotalDefaultRecords(panelistData[0]?.totalCount);
              setTotalRecords(panelistData[0]?.totalCount);
            } else {
              handleSnackbarMessage(
                res?.data?.message ||
                  "Failed to fetch panelist data, Please contact to dev team",
                "error",
              );
            }
          } else {
            handleSnackbarMessage("Something went wrong", "error");
          }
        })
        .catch((err) => {
          console.log("err", err.message);
        })
        .finally(() => setPageloading(false));
    }
  }, [selectedPanel]);

  useEffect(() => {
    setColumns([
      {
        name: "PanelistId",
        selector: (row) => row.panelistId,
        sortable: true,
        cell: (row) => (
          <Stack direction={"row"}>
            <Link
              to={`/admin/panelist-detail/${row.panelistId}`}
              state={{ type: "EDIT", panelistId: row.panelistId }}
              target="_blank"
            >
              {row.panelistId}
            </Link>
          </Stack>
        ),
      },
      {
        name: "First Name",
        selector: (row) => row.firstName || "--",
        sortable: true,
      },
      {
        name: "Last Name",
        selector: (row) => row.lastName || "--",
        sortable: true,
      },
      {
        name: "Join Date",
        selector: (row) =>
          row?.joinDate ? moment(row.joinDate).format("DD-MM-YYYY") : "--",
        sortable: true,
      },
      {
        name: "E-mail",
        selector: (row) => (
          <CustomTooltip
            title={row.email || "Email Not Found"}
            childrenText={row.email || "--"}
            copiedText
          />
        ),
        sortable: true,
      },
      {
        name: "Source",
        selector: (row) => (
          <CustomTooltip
            title={row.source || "Source Not Found"}
            childrenText={row.source || "--"}
          />
        ),
        sortable: true,
      },
      {
        name: "Country",
        selector: (row) => (
          <CustomTooltip
            title={row.countryName + "/" + row.language || "Country Not Found"}
            childrenText={row.countryCode || "--"}
          />
        ),
        sortable: true,
      },
      ...(showStatusColumn
        ? [
            {
              name: "Status",
              selector: (row) => row.isActive,
              sortable: true,
              cell: (row) => (
                <span
                  style={{
                    color: row.isActive ? "green" : "red",
                    fontWeight: "bold",
                  }}
                >
                  {row.isActive ? "Active" : "Inactive"}
                </span>
              ),
            },
          ]
        : []),
    ]);
    setPending(false);
  }, [showStatusColumn]);

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    if (query === "") {
      setFilteredData(defaultData);
      setTotalRecords(totalDefaultRecords);
      setShowStatusColumn(false);
    }
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleGetAllPanelist(page, rowsPerPage);
  };

  // const filteredData = panelists.filter((item) => {
  //   const values = Object.values(item);
  //   return values.find(
  //     (value) =>
  //       value != null &&
  //       value.toString().toLowerCase().includes(searchQuery.toLowerCase()),
  //   );
  // });

  useEffect(() => {
    if (searchQuery === "") {
      setFilteredData(defaultData); // reset to default data
    } else {
      const filtered = defaultData.filter((item) => {
        const values = Object.values(item);
        return values.some(
          (value) =>
            value !== null &&
            value.toString().toLowerCase().includes(searchQuery.toLowerCase()),
        );
      });
      setFilteredData(filtered);
    }
  }, [searchQuery, defaultData]);

  const callActiveOrInActiveUserApi = (apiName) => {
    handleGetAllPanelist(currentPage, rowsPerPage);
  };

  const handleDropDownChange = (e) => {
    if (e.target.value == "Inactive") {
      setSelectedUserStatusType(userActiveStatusData[1]);
      callActiveOrInActiveUserApi(userActiveStatusData[1].ApiName);
    } else {
      setSelectedUserStatusType(userActiveStatusData[0]);
      callActiveOrInActiveUserApi(userActiveStatusData[0].ApiName);
    }
  };

  const handleGetAllPanelist = (page = currentPage, perPage = rowsPerPage) => {
    try {
      getAllPanelistByPanelId(searchQuery, page, perPage)
        .then((res) => {
          if (res?.status === 200) {
            if (res?.data?.success) {
              setPanelists(res.data.data);
              setFilteredData(res?.data?.data);
              setTotalRecords(res.data?.data[0]?.totalCount);
            } else {
              if (page > 1) {
                setCurrentPage(1);
                handleGetAllPanelist(1, perPage);
              } else {
                handleSnackbarMessage(
                  res?.data?.message ||
                    "Failed to fetch panelist data, Please contact to dev team",
                  "error",
                );
              }
            }
          } else {
            handleSnackbarMessage("Something went wrong", "error");
          }
        })
        .finally(() => {
          setLoading(false);
          setPageloading(false);
          setPending(false);
        });
    } catch (error) {
      handleSnackbarMessage("Something went wrong", "error");
      setPending(false);
    }
  };
  const handleSubmit = () => {
    if (!searchQuery) {
      handleSnackbarMessage(
        "Please enter search query before submit.",
        "error",
      );
      return;
    }
    setLoading(true);
    setCurrentPage(1);
    setShowStatusColumn(true);
    handleGetAllPanelist(1, rowsPerPage);
  };

  const handleDownload = () => {
    if (!filteredData || filteredData.length === 0) {
      handleSnackbarMessage("No records available for this Panelist.", "error");
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Panelist Detail");
    XLSX.writeFile(workbook, "Panelist_Detail.xlsx");
  };

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={handleCloseSnackbar}
      >
        <Alert
          severity={
            snackbarSeverity === "success" ? undefined : snackbarSeverity
          }
          onClose={handleCloseSnackbar}
          sx={{
            width: "100%",
            backgroundColor:
              snackbarSeverity === "success" ? "#2196f3" : undefined, // Blue for success
            color: snackbarSeverity === "success" ? "#fff" : undefined, // White text for blue background
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <AnimatedPage>
        <TopHeading showButton={false} heading="Panelist Detail" />

        <Paper sx={{ px: 6, py: 1, mx: 2, mb: 2 }} elevation={1}>
          <Stack
            direction={"row"}
            sx={{ mb: 2, my: 2 }}
            spacing={2}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Grid container spacing={2}>
              {/* <Grid item xs={3} sm={3} md={3}>
                <FormControl sx={{ width: 205 }}>
                  <InputLabel id="demo-userStatus-label">Status</InputLabel>
                  <Select
                    id="demo-multiple-checkbox"
                    value={selectedUserStatusType}
                    onChange={handleDropDownChange}
                    renderValue={(selectedUserStatusType) =>
                      selectedUserStatusType.userActiveStatus
                    }
                    sx={{
                      width: 150,
                      height: 50,
                    }}
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    label="Status"
                  >
                    {userActiveStatusData.map((option) => (
                      <MenuItem
                        key={option.userActiveStatus}
                        value={option.userActiveStatus}
                      >
                        <ListItemText primary={option.userActiveStatus} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid> */}

              <Grid item xs={6} sm={6} md={6}>
                <TextField
                  type="search"
                  value={searchQuery}
                  fullWidth
                  label="Search"
                  name="Search"
                  onChange={handleSearch}
                />
              </Grid>
              <Grid item xs={2} sm={2} md={2}>
                <Button
                  fullWidth
                  variant="contained"
                  type="button"
                  disabled={loading}
                  sx={{ mt: 2 }}
                  onClick={handleSubmit}
                >
                  {loading ? <CircularProgress size={24} /> : "Submit"}
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={3} sm={3} md={3}>
              <Button
                fullWidth
                variant="contained"
                type="button"
                color="success"
                startIcon={<DownloadIcon />}
                sx={{ mt: 2 }}
                onClick={handleDownload}
              >
                {"Download"}
              </Button>
            </Grid>
          </Stack>
        </Paper>

        <Stack spacing={2} sx={{ mx: 4, my: 2 }}>
          <div>
            <CustomDataTable
              columns={columns}
              data={filteredData}
              pagination={true}
              progressPending={pending}
              highlightOnHover
              paginationServer={true}
              paginationTotalRows={totalRecords}
              paginationPerPage={rowsPerPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={(newPerPage, page) => {
                setRowsPerPage(newPerPage);
                setCurrentPage(page);
                handleGetAllPanelist(page, newPerPage);
              }}
            />
          </div>
        </Stack>
      </AnimatedPage>
    </>
  );
};

export const EnhancedPanelistsPage = Hoc(Panelists, { name: "" });
